export default __webpack_public_path__ + "static/media/yes6.51190070.gif";